import { Button, Form, Modal, Tab, Nav } from "react-bootstrap";
import PropTypes from "prop-types";
import Messages from "../message";
import { ERROR } from "../../assets/constant";
import { useState } from "react";
import { SignatureManager } from "../signature-manager";

export const ReportIssueModal = ({
  showModal,
  onClose,
  handleSubmit,
  email,
  alert,
  alertMessage,
  alertClose,
  userId,
  recallId,
  recallType
}) => {
  const [contactError, setContactError] = useState(false);
  const [activeTab, setActiveTab] = useState('report');

  const handleContactChange = (e) => {
    const contact = e.target.value;
    console.log(contact);
    if (isNaN(contact)) {
      setContactError(true);
    }
    if (contact.length === 10) {
      setContactError(false);
    }
    if (contact.length > 10 || contact.length < 10) {
      setContactError(true);
    }
  };

  return (
    <Modal 
      show={showModal} 
      onHide={onClose}
      size="lg"
      className="report-issue-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Report an Issue</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="tabs" className="mb-3 report-issue-tab">
            <Nav.Item>
              <Nav.Link eventKey="report">
                <i className="fas fa-exclamation-triangle me-1"></i>
                Report Issue
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="signature">
                <i className="fas fa-file-signature me-1"></i>
                Signature
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="report">
              {alert && (
                <Messages type={ERROR} onClose={alertClose} message={alertMessage} />
              )}
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    name="email"
                    type="email"
                    value={email}
                    disabled
                    placeholder="Enter your email"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="formContact" className="mb-3">
                  <Form.Label>Contact</Form.Label>
                  <Form.Control
                    type="tel"
                    pattern="[0-9]{10}"
                    name="contact"
                    placeholder="Enter your contact"
                    title="Phone number should be 10 digits"
                    onChange={handleContactChange}
                    required
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                  {contactError && (
                    <div className="text-danger py-1">
                      Phone number should be 10 digits
                    </div>
                  )}
                </Form.Group>
                <Form.Group controlId="formIssueDetails" className="mb-3">
                  <Form.Label>Issue Details</Form.Label>
                  <Form.Control name="description" as="textarea" rows={3} required />
                </Form.Group>
                <Form.Group controlId="formAttachment" className="mb-3">
                  <Form.Label>Attachment</Form.Label>
                  <Form.Control name="IssuesAttach" type="file" />
                </Form.Group>
                <Modal.Footer>
                  <Button className="recallButton" type="submit">
                    Submit
                  </Button>
                </Modal.Footer>
              </Form>
            </Tab.Pane>

            <Tab.Pane eventKey="signature">
              <SignatureManager 
                userId={userId}
                recallId={recallId}
                recallType={recallType}
                onSignatureUpdate={() => {
                  // Optional callback when signature is updated
                  console.log('Signature updated');
                }}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </Modal>
  );
};

ReportIssueModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  alert: PropTypes.bool,
  alertMessage: PropTypes.string,
  alertClose: PropTypes.func,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  recallId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  recallType: PropTypes.number
};

ReportIssueModal.defaultProps = {
  userId: '',
  recallId: '',
  recallType: 1
};